import { render, staticRenderFns } from "./QuoteVentilationSummaryDetailList.vue?vue&type=template&id=f740ac22&"
import script from "./QuoteVentilationSummaryDetailList.vue?vue&type=script&lang=ts&"
export * from "./QuoteVentilationSummaryDetailList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports